<template>
  <div class="iftttNotice_options_item iftttNotice_options_time">
    <ifttt-option-left :num="isTriggle && isAction ? 3 : !isTriggle && !isAction ? 1 : 2" :label="$t('iftttset.effectivetime')" />
    <div class="iftttNotice_option_right">
      <ul v-if="!!effectiveTimeData" @click="showDataDialog">
        <li class="iftttNotice_options_time_item">
          <span>{{ $t('iftttset.repeat') }} : </span>
          <span>{{ effectiveTimeData.repeatInfo }}</span>
          <el-button type="text" class="ifttt_del_button" @click.stop="deleteEffectiveTimeData">
            <i class="icon--1" />
          </el-button>
        </li>
        <li class="iftttNotice_options_time_item">
          <span>{{ $t('iftttset.data') }} : </span>
          <span v-if="effectiveTimeData.dayInfo">
            {{ effectiveTimeData.dayInfo }}
          </span>
        </li>
        <li v-if="isShowTime" class="iftttNotice_options_time_item">
          <span>{{ $t('iftttset.time') }} : </span>
          <span v-if="effectiveTimeData.timeInfo">
            {{ effectiveTimeData.timeInfo }}
          </span>
        </li>
      </ul>
      <el-dropdown
        v-else
        trigger="click"
        class="dialog_add text-button"
        @command="onDropdownOptionsCommand"
      >
        <span class="el-dropdown-link">
          {{ $t('iftttset.adddata') }}
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in dropdownOptions" :key="index" :command="item.value">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <iffttt-effect-time-dialog
      ref="IfftttEffectTimeDialog"
      :visible="dataDialogVisible"
      :page-type="pageType"
      :effective-time-data="effectiveTimeData"
      :trigger-manual="triggerManual"
      @effectTimeChange="onEffectTimeChange"
      @close="hidenDataDialog"
    />
  </div>
</template>

<script>
import { alertsuccess } from '@/assets/js/common.js'
import IftttOptionLeft from './IftttOptionLeft'
import IfftttEffectTimeDialog from './IfftttEffectTimeDialog.vue'
import { parseDate, parseMonth } from '@/utils/utils.js'
import { isIot3,isIot1 } from "@utils/utils";

export default {
  components: {
    IftttOptionLeft,
    IfftttEffectTimeDialog,
  },
  props: {
    pageType: {
      type: String,
      default: 'create',
    },
    initData: {
      type: Object,
      default: () => ({}),
    },
    triggerManual: {
      type: Boolean,
      default: false,
    },
    initPanelData: {
      type: Object,
      default: () => ({}),
    },
    isTriggle: {
      // 显示如果
      type: Boolean,
      default: true,
    },
    isAction: {
      // 显示就执行
      type: Boolean,
      default: true,
    },
    isShowTime: {
      // 显示时间
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      effectiveTimeData: {
        dayInfo: `2019-01-01 ${this.$t('sylogs.to')} 2088-12-31`,
        effectivedate: '2019-01-01,2088-12-31',
        endDay: '2088-12-31',
        flag: 1,
        holiday: false,
        repeatInfo: this.$t('iftttset.every'),
        startDay: '2019-01-01',
        time: '00:00',
        timeInfo: this.$t('iftttset.allday'),
        weeks: 'Mon Tues Wed Thur Fri Sat Sun',
        zone: 0,
      },
      dropdownOptions: [
        {
          value: 1,
          label: this.$t('iftttset.effectivetime'),
        },
      ],
      dataDialogVisible: false,
      weekList: [
        { name: this.$t('iftttset.Mon'), selected: true, value: 'Mon', type: 0 },
        { name: this.$t('iftttset.Tues'), selected: true, value: 'Tues', type: 0 },
        { name: this.$t('iftttset.Wed'), selected: true, value: 'Wed', type: 0 },
        { name: this.$t('iftttset.Thur'), selected: true, value: 'Thur', type: 0 },
        { name: this.$t('iftttset.Fri'), selected: true, value: 'Fri', type: 0 },
        { name: this.$t('iftttset.Sat'), selected: true, value: 'Sat', type: 1 },
        { name: this.$t('iftttset.Sun'), selected: true, value: 'Sun', type: 1 },
      ],
      weekTemp: [
        { name: this.$t('iftttset.every'), selected: false, value: 'every', flag: 1, weeks: ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'] },
        {
          name: this.$t('iftttset.customize'),
          selected: false,
          value: 'customize',
          flag: [1, 4, 5, 6],
        },
        { name: this.$t('iftttset.wordDay'), selected: false, value: 'wordDay', flag: 1 },
        { name: this.$t('iftttset.weekEnd'), selected: false, value: 'weekEnd', flag: 1 },
        { name: this.$t('iftttset.holidays'), selected: true, value: 'holidays', flag: 3 },
        { name: this.$t('iftttset.notHolidays'), selected: false, value: 'notHolidays', flag: 2 },
        { name: this.$t('iftttset.executeOnlyOnce'), selected: false, value: 'executeOnlyOnce', flag: 1, weeks: ['once'] },
      ],
      weekTemp2: [
        { name: this.$t('iftttset.every'), selected: false, value: 'every', flag: 1, weeks: ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'] },
        {
          name: this.$t('iftttset.customize'),
          selected: false,
          value: 'customize',
          flag: [1, 4, 5, 6],
        },
        { name: this.$t('iftttset.wordDay'), selected: false, value: 'wordDay', flag: 1 },
        { name: this.$t('iftttset.weekEnd'), selected: false, value: 'weekEnd', flag: 1 },
      ],
      timeTemp: [
        { name: this.$t('iftttset.allday'), selected: true, value: 'allday' },
        { name: this.$t('iftttset.customize'), selected: false, value: 'customize' },
      ],
      dateTemp: [
        { name: this.$t('iftttset.along'), selected: true, value: 'along' },
        { name: this.$t('iftttset.customize'), selected: false, value: 'customize' },
      ],
      isCreateIfttt: true,
    }
  },

  watch: {
    //针对自定义自动化 获取最新的prop
    initData(newVal, oldValue) {
       const days = this.getWeekOptions()
      this.effectiveTimeData = this.getNameFromFlagAndData(newVal, days)
      console.log(this.effectiveTimeData)
      // this.initTimeData()
    },
    initPanelData(newVal, oldValue) {
      const days = this.getWeekOptions()
      this.effectiveTimeData = this.getNameFromFlagAndData(newVal, days)
      // this.initTimeData()
    },
  },
  created() {
    const days = this.getWeekOptions()
    //模版自动化
    if (Object.keys(this.initData).length > 0 && this.pageType === 'edit') {
      this.effectiveTimeData = this.getNameFromFlagAndData(this.initData, days)
    }
    if (Object.keys(this.initPanelData).length > 0) {
      this.effectiveTimeData = this.getNameFromFlagAndData(this.initPanelData, days)
    }
  },

  beforeDestroy() {
    this.$emit('getFullData', this.effectiveTimeData)
  },

  methods: {
    isIot1,
    getWeekOptions() {
      return !this.isIot1() ? this.weekTemp : this.weekTemp2
    },
    getNameFromFlagAndData(apiData, options) {
      const result = {}
      if (Object.keys(apiData).length === 0) {
        return {}
      }
      // 解构 apiData 中的字段
      const { flag = 1, weeks, time } = apiData

      if (time === '00:00') {
        result.timeInfo = this.$t('iftttset.allday')
      } else {
        const _temst = parseInt(time.split(':')[0])
        const _temed = parseInt(time.split(':')[1])
        if (_temed > _temst) {
          result.timeInfo = time.split(':')[0] + ' ' + this.$t('iftttset.to') + ' ' + time.split(':')[1]
        } else {
          result.timeInfo = time.split(':')[0] + ' ' + this.$t('iftttset.to') + ' ' + this.$t('iftttset.tommrow') + time.split(':')[1]
        }
      }
    

      // 遍历 options，找到匹配项
      for (const option of options) {
        const isFlagMatch = Array.isArray(option.flag) ? option.flag.includes(flag) : option.flag === flag

        if (isFlagMatch) {
          if (flag === 1) {
            // 如果 flag 是 1，需要进一步判断 weeks
            if (option.value === 'executeOnlyOnce' && weeks === 'Once') {
              result.repeatInfo = option.name // 匹配 "执行一次"
              break
            }
            if (option.value === 'every' && weeks.split(' ').length === 7) {
              result.repeatInfo = option.name // 匹配 "每天"
              break
            }
            if (option.value === 'customize') {
              const workDays = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri'].join(' ')
              const weekends = ['Sat', 'Sun'].join(' ')
              const everyDay = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'].join(' ')

              // weeks 不是 once、每天、工作日、周末，则为自定义
              if (weeks !== 'Once' && weeks !== everyDay && weeks !== workDays && weeks !== weekends) {
                result.repeatInfo = option.name // 匹配 "自定义"
                break
              }
            }
            if (option.value === 'wordDay' && weeks === ['Mon', 'Tues', 'Wed', 'Thur', 'Fri'].join(' ')) {
              result.repeatInfo = option.name // 匹配 "自定义"
              break
            }
            if (option.value === 'weekEnd' && weeks === ['Sat', 'Sun'].join(' ')) {
              result.repeatInfo = option.name // 匹配 "自定义"
              break
            }
          } else if (flag === 4 || flag === 5 || flag === 6) {
            
            const parsedData = this.parseMonthlyTimePeriod(apiData)
            Object.assign(result, parsedData)
            if (option.value === 'customize') {
              result.repeatInfo = option.name
              break
            }
          } else {
            // 直接根据 flag 返回匹配项
            result.repeatInfo = option.name
            break
          }
        }
      }

      if (!result.dayInfo) {
        result.dayInfo = `2019-01-01 ${this.$t('sylogs.to')} 2088-12-31 `
      }

      // 返回更新后的 apiData，添加新的 key
      const mergeData = { ...result, ...apiData }
      if (flag === 6 && result.effectivedate) {
        mergeData.dayInfo = result.dayInfo
        mergeData.effectivedate = result.effectivedate
      }
      return mergeData
    },

    parseMonthlyTimePeriod(timePeriod) {
      const result = {}
      const { flag, date, month, startYear, startMonth, startDay, endYear, endMonth, endDay } = timePeriod

      if (flag === 4) {
        // 每月：解析 date 位掩码
        const days = parseDate(date)
        result.customType = 2 // MONTH
        result.selectMonthDateList = days.map(d => `2099-01-${String(d).padStart(2, '0')}`)
      } else if (flag === 5) {
        // 每年：解析 month 位掩码 + date 位掩码
        const months = parseMonth(month)
        const days = parseDate(date)
        result.customType = 3 // YEAR
        result.selectedMonths = months
        result.selectYearDateList = days.map(d => `2099-01-${String(d).padStart(2, '0')}`)
      } else if (flag === 6) {
        // 日期范围
        result.customType = 4 // DATE_RANGE
        if (startYear && startMonth && startDay && endYear && endMonth && endDay) {
          const startDate = `${startYear}-${String(startMonth).padStart(2, '0')}-${String(startDay).padStart(2, '0')}`
          const endDate = `${endYear}-${String(endMonth).padStart(2, '0')}-${String(endDay).padStart(2, '0')}`
          result.dataPickValue = [startDate, endDate]
          result.dayInfo = `${startDate} ${this.$t('sylogs.to')} ${endDate}`
          result.effectivedate = `${startDate},${endDate}`
        }
      }

      return result
    },

    getSaveData() {
      const defaultData = {
        effectivedate: '2019-01-01,2088-12-31',
        holiday: false,
        time: '00:00',
        weeks: 'Mon Tues Wed Thur Fri Sat Sun',
        zone: 0,
        flag: 1,
        month: 0,
        date: 0,
        startYear: 0,
        startMonth: 0,
        startDay: 0,
        endYear: 0,
        endMonth: 0,
        endDay: 0
      }
      
      const { 
        effectivedate, 
        holiday, 
        time, 
        weeks, 
        zone, 
        flag,
        month,
        date,
        startYear,
        startMonth,
        startDay,
        endYear,
        endMonth,
        endDay
      } = this.effectiveTimeData || defaultData
      
      return { effectivedate, holiday, time, weeks, zone, flag, month, date, startYear, startMonth, startDay, endYear, endMonth, endDay }
    },
    getFullData() {
      return this.effectiveTimeData
    },
    onEffectTimeChange(data) {
      this.effectiveTimeData = data
    },

    deleteEffectiveTimeData() {
      this.effectiveTimeData = null
      this.$refs.IfftttEffectTimeDialog.initData()

      alertsuccess(this, this.$store.state.rightStatusCode)
    },

    onDropdownOptionsCommand(value) {
      if (value === 1) {
        this.showDataDialog()
      }
    },

    showDataDialog() {
      this.dataDialogVisible = true
    },

    hidenDataDialog() {
      this.dataDialogVisible = false
    },
  },
}
</script>

<style lang="scss">
.iftttNotice_options_time {
  &_item {
    position: relative;
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: dashed 1px #d6dce1;
    text-indent: 20px;

    &:first-child {
      padding-top: 0;

      &::before {
        top: 8px;
      }
    }

    &::before {
      position: absolute;
      content: '';
      width: 5px;
      height: 5px;
      top: 25px;
      left: 0;
      font-size: 10px;
      border-radius: 50%;
      text-indent: -16px;
      background-color: #717171;
    }
  }
}
</style>
